import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-m-4" }
const _hoisted_2 = {
  for: "dataSource",
  class: "kn-material-input-label",
  "aria-label": "dropdown"
}
const _hoisted_3 = {
  key: 0,
  class: "p-error p-grid"
}
const _hoisted_4 = { class: "p-col-12" }
const _hoisted_5 = {
  key: 0,
  class: "p-mt-4"
}
const _hoisted_6 = { class: "kn-material-input-label" }
const _hoisted_7 = {
  key: 1,
  class: "p-mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _createVNode("span", null, [
        _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('managers.lovsManagement.dataSource')) + " * ", 1),
        _createVNode(_component_Dropdown, {
          id: "dataSource",
          class: ["kn-material-input", {
                        'p-invalid': !_ctx.query.datasource && _ctx.dirty
                    }],
          modelValue: _ctx.query.datasource,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.query.datasource = $event)),
          options: _ctx.datasources,
          optionLabel: "label",
          optionValue: "label",
          placeholder: _ctx.$t('managers.lovsManagement.placeholderDatasource'),
          "aria-label": "dropdown",
          onBeforeShow: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dirty = true)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched')))
        }, null, 8, ["class", "modelValue", "options", "placeholder"])
      ]),
      (!_ctx.query.datasource && _ctx.dirty)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode("small", _hoisted_4, _toDisplayString(_ctx.$t('common.validation.required', {
                            fieldName: _ctx.$t('managers.lovsManagement.dataSource')
                        })), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.query.datasource)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.lovsManagement.queryDefinition')), 1),
          _createVNode(_component_VCodeMirror, {
            ref: "codeMirror",
            class: "p-mt-2",
            value: _ctx.code,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.code = $event)),
            autoHeight: true,
            options: _ctx.options,
            onKeyup: _ctx.onKeyUp
          }, null, 8, ["value", "options", "onKeyup"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.query.datasource)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _createVNode("small", null, _toDisplayString(_ctx.$t('managers.lovsManagement.queryColumnsNameNotAllowed')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}